import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PopupComponent } from 'src/app/elements/popup/popup.component'

@Component({
  standalone: true,
  selector: 'app-paynow-infos',
  templateUrl: './paynow-infos.component.html',
  styleUrl: './paynow-infos.component.sass',
})
export class PaynowInfosComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: PageContext<RedirectorPaynowConfig>,
    @Inject(MatDialogRef) protected dialog: MatDialogRef<PopupComponent>,
  ) {}

  close () {
    this.dialog.close()
  }
}
